import React from 'react';

export const Backward = () => (
    <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.19 8.1">
        <g>
            <path d="M8.25,2.21H3.6V0L0,2.84l3.6,2.84V3.46h4.64c.93,0,1.69,.76,1.69,1.69s-.76,1.69-1.69,1.69h-1v1.25h1c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94Z"/>
        </g>
    </svg>
);
